// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IgvOqwGdB9cTRmLu {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
}

.IgvOqwGdB9cTRmLu button {
  margin: 0;
  width: 100%;
  height: 48px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  border: none;
}

.DQSMfnSHqoe6QGS5 {
  background-color: #56be4d;
  color: #fff;
}

.DQSMfnSHqoe6QGS5:hover {
  background-color: #4eac46;
}
.DQSMfnSHqoe6QGS5:active {
  background-color: #44963d;
}
.DQSMfnSHqoe6QGS5:disabled {
  background-color: #cfeed9;
  color: #8cbf9a;
}

.CHIzGFmbMloEWUSR {
  background-color: #e1e7ed;
  color: #303030;
}

.CHIzGFmbMloEWUSR:hover {
  background-color: #d5dce3;
}

.CHIzGFmbMloEWUSR:active {
  background-color: #c7cfd7;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chef/components/SendStationStatisticModal/components/SendStationModalFooter/SendStationModalFooter.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".actions {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.actions button {\r\n  margin: 0;\r\n  width: 100%;\r\n  height: 48px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.sendButton {\r\n  background-color: #56be4d;\r\n  color: #fff;\r\n}\r\n\r\n.sendButton:hover {\r\n  background-color: #4eac46;\r\n}\r\n.sendButton:active {\r\n  background-color: #44963d;\r\n}\r\n.sendButton:disabled {\r\n  background-color: #cfeed9;\r\n  color: #8cbf9a;\r\n}\r\n\r\n.cancelButton {\r\n  background-color: #e1e7ed;\r\n  color: #303030;\r\n}\r\n\r\n.cancelButton:hover {\r\n  background-color: #d5dce3;\r\n}\r\n\r\n.cancelButton:active {\r\n  background-color: #c7cfd7;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var actions = `IgvOqwGdB9cTRmLu`;
export var sendButton = `DQSMfnSHqoe6QGS5`;
export var cancelButton = `CHIzGFmbMloEWUSR`;
export default ___CSS_LOADER_EXPORT___;
